function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Pin"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.7 0C79.1 0 28.3 42.8 28.3 107c0 74.2 113.4 176.5 113.4 176.5S255.1 181.2 255.1 107c0-64.2-50.7-107-113.4-107zm0 243.8c-9.9-10.2-22.6-23.8-35.1-39.3-43.4-53.5-49.9-84.1-49.9-97.6 0-22.7 8.3-42.3 24-56.6 15.6-14.2 37.2-22 61-22s45.5 7.8 61 22c15.7 14.3 24 33.9 24 56.6 0 13.5-6.5 44.1-49.9 97.6-12.5 15.5-25.1 29.2-35.1 39.3z"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(1 -.00368 .00368 1 -.39 .522)",
  cx: "141.7",
  cy: "106.3",
  r: "28.4"
}))));